var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('vue-headful',{attrs:{"title":"ToDo - About","description":"todo list"}}),_c('h1',[_vm._v("This is application for my portfolio :)")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }